import { composeIO } from 'react-compose-io'
import { itemCicloPedidoIO } from './ItemCicloPedido.IO'
import { ItemCicloPedidoView } from './ItemCicloPedido.View'

export const ItemCicloPedido = composeIO(ItemCicloPedidoView, itemCicloPedidoIO)
